export default {
  navigation: function navigation(state) {
    return state.navigation;
  },
  navigationServices: function navigationServices(state) {
    return state.navigationServices;
  }
};